import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromBookableSlot from '../bookable-slot/bookable-slot.reducer'
import { BookableSlotEffects } from './bookable-slot.effects'
import { BookableSlotSerializer } from './bookable-slot.serializer'
import { BookableSlotService } from './bookable-slot.service'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromBookableSlot.FEATURE_NAME,
      fromBookableSlot.bookableSlotReducer
    ),
    EffectsModule.forFeature([BookableSlotEffects])
  ],
  providers: [
    BookableSlotService,
    {
      provide: BookableSlotSerializer,
      useClass: BookableSlotSerializer
    }
  ],
  declarations: [],
  exports: []
})
export class BookableSlotModule {}
